export default __webpack_public_path__ + "static/media/ctbc.44c0e7b0.png";